"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IconButton_1 = require("@material-ui/core/IconButton");

var FirstPage_1 = require("@material-ui/icons/FirstPage");

var KeyboardArrowLeft_1 = require("@material-ui/icons/KeyboardArrowLeft");

var KeyboardArrowRight_1 = require("@material-ui/icons/KeyboardArrowRight");

var LastPage_1 = require("@material-ui/icons/LastPage");

var makeStyles_1 = require("@material-ui/styles/makeStyles");

var React = require("react");

var useStyles = makeStyles_1["default"]({
  root: {
    flexShrink: 0
  }
});

var getPages = function getPages(currentPage, totalRows, rowsPerPage) {
  var pages = []; // Default page limits

  var totalPages = Math.ceil(totalRows / rowsPerPage);
  var startPage = 1;
  var endPage = totalPages;
  var maxSize = 6;
  var isMaxSized = maxSize < totalPages; // recompute if maxSize

  if (isMaxSized) {
    // Current page is displayed in the middle of the visible ones
    startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
    endPage = startPage + maxSize - 1; // Adjust if limit is exceeded

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = endPage - maxSize + 1;
    }
  } // Add page number links


  for (var num = startPage; num <= endPage; num++) {
    pages.push(num - 1);
  }

  return pages;
};

exports.AdvancePaginationActions = function (_a) {
  var count = _a.count,
      isAdvanced = _a.isAdvanced,
      isLoading = _a.isLoading,
      page = _a.page,
      rowsPerPage = _a.rowsPerPage,
      onChangePage = _a.onChangePage;
  var classes = useStyles({});
  var pages = getPages(page, count, rowsPerPage);
  var lastPage = Math.ceil(count / rowsPerPage) - 1;

  var gotoPage = function gotoPage(value) {
    return function (e) {
      return onChangePage(e, value);
    };
  };

  var gotoFirstPage = gotoPage(0);
  var gotoPrevPage = gotoPage(page - 1);
  var gotoNextPage = gotoPage(page + 1);
  var gotoLastPage = gotoPage(Math.max(0, lastPage));
  var canNotBack = page === 0 || isLoading;
  var canNotFwd = page === lastPage || isLoading;
  return React.createElement("div", {
    className: classes.root
  }, isAdvanced && React.createElement(IconButton_1["default"], {
    onClick: gotoFirstPage,
    disabled: canNotBack,
    "aria-label": 'First Page'
  }, React.createElement(FirstPage_1["default"], null)), React.createElement(IconButton_1["default"], {
    onClick: gotoPrevPage,
    disabled: canNotBack,
    "aria-label": 'Previous Page'
  }, React.createElement(KeyboardArrowLeft_1["default"], null)), isAdvanced && pages.map(function (value) {
    return React.createElement(IconButton_1["default"], {
      key: value,
      onClick: gotoPage(value),
      disabled: value >= Math.ceil(count / rowsPerPage) || isLoading,
      "aria-label": "Page " + (value + 1),
      color: value === page ? 'primary' : 'default'
    }, value + 1);
  }), React.createElement(IconButton_1["default"], {
    onClick: gotoNextPage,
    disabled: canNotFwd,
    "aria-label": 'Next Page'
  }, React.createElement(KeyboardArrowRight_1["default"], null)), isAdvanced && React.createElement(IconButton_1["default"], {
    onClick: gotoLastPage,
    disabled: canNotFwd,
    "aria-label": 'Last Page'
  }, React.createElement(LastPage_1["default"], null)));
};